import api from "../libs/api";

export default {
  getAll: (page, perPage, sortBy = "", sortOrder = "") => {
    return new Promise((resolve, reject) => {
      const queryParams = new URLSearchParams({
        page,
        perPage,
        sortBy,
        sortOrder,
      }).toString();

      api()
        .get(`/infra-change-request-form?${queryParams}`)
        .then(({ status, data }) => {
          if (status === 200) {
            resolve(data);
          } else {
            throw new Error(`Failed with status: ${status}`);
          }
        })
        .catch((error) => reject(error));
    });
  },

  getById: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/infra-change-request-form/${id}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data.data);
          else throw new Error(`Failed with status: ${status}`);
        })
        .catch((error) => reject(error));
    });
  },

  store: (data) => {
    return new Promise((resolve, reject) => {
      api()
        .post("infra-change-request-form", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ status, data }) => {
          if (status === 201) {
            resolve(data);
          }
        })
        .catch((error) => reject(error));
    });
  },

  update: (id, data) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`infra-change-request-form/${id}?_method=PUT`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ status, data }) => {
          if (status === 201) {
            resolve(data);
          }
        })
        .catch((error) => reject(error));
    });
  },

  delete: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .delete(`infra-change-request-form/${id}`)
        .then(({ status, data }) => {
          if (status === 200) {
            resolve(data);
          }
        })
        .catch((error) => reject(error));
    });
  },

  search: (fields) => {
    return new Promise((resolve, reject) => {
      const filteredFields = Object.entries(fields).filter(
        ([key, value]) =>
          value !== undefined && value !== "" && typeof value !== "object"
      );
      const queryString = filteredFields
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");

      api()
        .get(`/infra-change-request-form-filters?${queryString}`)
        .then(({ status, data }) => {
          if (status === 200) {
            resolve(data);
          } else {
            throw new Error(`Failed with status: ${status}`);
          }
        })
        .catch((error) => reject(error));
    });
  },
};
